export default {
  namespaced: true,
  state: {
    endpoint: 'appdeudores/usuarios',
    loading: false,
    usuarios: [],
    total: 0
  },
  getters: {
    endpoint: state => state.endpoint,
    loading: state => state.loading,
    usuarios: state => state.usuarios,
    total: state => state.total
  },
  mutations: {
    setLoading: (state, payload) => (state.loading = payload),
    setUsuarios: (state, payload) =>
      (state.usuarios = [...payload.datos]),
    settotal: (state, payload) => (state.total = payload),
    setClearusuarios: state => (state.usuarios = [])
  },
  actions: {
    get ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((res, rej) => {
        this.dispatch('index', {
          endpoint: state.endpoint,
          params: payload
        })
          .then(response => {
            payload.page == 1 ? commit('setUsuarios') : null
            commit('setUsuarios', {
              datos: response.datos,
              page: payload.page
            })
            commit('settotal', response.total)
            res(response.datos)
          })
          .catch(error => rej(error.response))
          .then(() => {
            commit('setLoading', false)
          })
      })
    },
    changePasswod ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((res, rej) => {
        this.dispatch('edit', {
          endpoint: state.endpoint+"/changepassword",
          params: payload
        })
          .then(response => {
            res(response.datos)
          })
          .catch(error => rej(error.response))
          .then(() => {
            commit('setLoading', false)
          })
      })
    },search ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((res, rej) => {
        this.dispatch('index', {
          endpoint: state.endpoint+"/search",
          params: payload
        })
          .then(response => {
            payload.page == 1 ? commit('setUsuarios') : null
            commit('setUsuarios', {
              datos: response.datos,
              page: payload.page
            })
            commit('settotal', response.total)
            res(response.datos)
          })
          .catch(error => rej(error.response))
          .then(() => {
            commit('setLoading', false)
          })
      })
    },update ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((res, rej) => {
        this.dispatch('edit', {
          endpoint: state.endpoint+"/update",
          params: payload
        })
          .then(response => {
            res(response.datos)
          })
          .catch(error => rej(error.response))
          .then(() => {
            commit('setLoading', false)
          })
      })
    }
  }
}
